import { Link } from "react-router-dom";
import Logo from "../common/Logo";
import "./Footer.css";

function Footer() {
  const footerYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <Link to="/" className="site-footer__logo" aria-label="Home">
            <Logo />
          </Link>
          <p className="site-footer__copy">&copy; {footerYear} WSTN. All rights reserved.</p>
        </div>
        <nav className="site-footer__nav">
          <Link to="/capabilities" className="site-footer__link">Capabilities</Link>
          <Link to="/work" className="site-footer__link">Work</Link>
          <Link to="/bliss" className="site-footer__link">Bliss</Link>
          <Link to="/contact" className="site-footer__link">Contact</Link>
          <a href="https://github.com/weston1" className="site-footer__link">GitHub</a>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
